import React from 'react'
import { BusyButtonLink } from '../BusyButton/BusyButtonLink'
import { useError, useToast } from '@ztechapps/common.hook'
import { useCopyToClipboard } from 'react-use'

export type CopyToClipboardButtonProps = { textToCopy: string }
export const CopyToClipboardButton = ({ textToCopy }: CopyToClipboardButtonProps) => {
  const { showSuccess } = useToast()
  const [{ error }, copyToClipboard] = useCopyToClipboard()
  useError(error)

  const onCopy = () => {
    copyToClipboard(textToCopy)
    showSuccess({ message: 'Successfully copied the text to clipboard.' })
  }

  return <BusyButtonLink icon="copy" title="Copy text to clipboard" onClick={onCopy} />
}
